// action/streamCount.js

export const UPDATE_STREAM_COUNT = "UPDATE_STREAM_COUNT";
export const SET_STREAM_COUNT = "SET_STREAM_COUNT";

// “increment” approach for partial increments:
export const updateStreamCount = (payload) => {
  console.log("[Redux Action] => updateStreamCount called with payload:", payload);
  return {
    type: UPDATE_STREAM_COUNT,
    payload,
  };
};

// “set total” approach for a direct assignment:
export const setStreamCount = (total) => {
  console.log("[Redux Action] => setStreamCount called with total:", total);
  return {
    type: SET_STREAM_COUNT,
    payload: total,
  };
};